export default __webpack_public_path__ + "static/media/rule_hover.e83fd47d.svg";